export const NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME = 'title'

export const NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH = 255

export const NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_TICKER_MAX_LENGTH = 100

export const NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS = 2
